import React from "react";
import { useLocalStorage } from "usehooks-ts";

type TContext = {
  isLogin: boolean;
  token: string | null;
  toggleLogin: (token: string | null) => void;
};

const LoginContext = React.createContext<TContext>({
  isLogin: false,
  token: null,
  toggleLogin: () => {},
});

export const LoginContextProvider: React.FC = (props) => {
  const [isLogin, setIsLogin] = useLocalStorage("isLogin", false);
  const [token, setToken] = useLocalStorage<string | null>("token", null);

  function toggleLogin(newToken: string | null) {
    if (newToken) {
      setToken(newToken);
      setIsLogin(true);
    } else {
      setToken(null);
      setIsLogin(false);
    }
  }

  const loginValue: TContext = {
    isLogin,
    token,
    toggleLogin,
  };

  return (
    <LoginContext.Provider value={loginValue}>
      {props.children}
    </LoginContext.Provider>
  );
};

export default LoginContext;
